//module common {
export enum ActionType { Delete, Edit, Insert, Save, CopyFrom, Custom, FormButton, Cancel }
export enum BladeSlide { left, right }
export enum GridColumnDirection { none, ASC, DESC }
export enum GridAutoLoad { Never, Always, OnlyOneRecord }
export enum RecordUpdateAction { None, Insert, Update, Delete }
export enum EntityStyle { Classic, Blade }
export enum FormType { SelectList, Search }
export enum GridType { UIGrid, Dashboard, Inline }
export enum FieldType { String, Int, Bool, DateTime, Enum, Password, Float, Text, YesNo, Byte, Time, File, Guid, Button, Grid, Label, YesNoIgnore, Popup = 110, BloodPressure = 111, HistoryList = 112, MultiSelect = 200, LargeButton = 300, WacomSignature = 201, ReadOnlyLabel = 206 }
export enum DataObjectType { JsonString, Json, String }
export enum DataSourceStatus { Pending, Started, Success, Failed }
export enum MessageButtonType { Ok, Cancel, Close, Yes, No }
export enum ViewType {
  String, Dropdown, Text, CheckBox, IntNoFormat, DateFrequency, InputMask, Int, Slider, MultiSelect, Time, Pictures, TimeEstimate, Document, ContainerLayoutConfig, QRScanner, Date, Float, Switch, DateTime, RadioButton,
  AutoComplete, File, Signature, Password, CustomControl, YesNo, InputGroupString, Link, Currency, DateRange, YesNoIcon, Thumbnail, StatusChange, IntRange, Window, Button, Label, Popup, StringMask, MultipleInstance, LargeButton, ReadOnlyLabel, DateWithTime, AutoCompleteText
}
export enum WorkflowType {
  WorkflowRequisitionCreated,
  WorkflowApproved,
  WorkflowProcurementOfficer,
  WorkflowApprovalRequested,

  WorkflowItemApproved,
  WorkflowItemDeclined,
  WorkflowItemPending,
  WorkflowItemApprovalRequested,

  WorkflowPartialPurchaseOrderDispatched,
  WorkflowPartialIssuedToWarehouse,
  WorkflowPartialPending,
  WorkflowItemPermanentDeclined,
  WorkflowCancelled,
  WorkflowProcessing,
  WorkflowItemProcessed,
  WorkflowProcessed,
  WorkflowContractManagerApprovalRequested,
  WorkflowRejectedForCorrection,
  WorkflowPartialComplete,
  WorkflowRejectedForCorrectionOfficer,
  WorkflowItemRejectedForCorrectionOfficer,
  WorkflowCompleted, WorkflowGRND,
  WorkflowItemGRND,
  WorkflowItemPOGenerated,
  WorkflowItemComplete,
  WorkflowPartialItemGRND,
  WorkflowPartialItemPOGenerated,
  WorkflowIssuedToWarehouse,

  WorkflowProcurementAdminApprovalRequired,
  WorkflowProcurementBranchApprovalRequired,
  WorkflowFMApprovalRequested,
  WorkflowFDApprovalRequested
}


export enum ScaffoldRequestWorkflowTypes {
  Created,
  Submitted,
  PartialDeliveryScheduled,
  FullDeliveryScheduled,
  Completed,
  Cancelled,
  None,
  ApprovalRequested,
  Approved,
  Rejected,
  ContractManagerApprovalRequested,
  ContractManagerApproved,
  ContractManagerRejected
}

export enum WhereExpressionType {
  Contains = 1,
  Equals = 2,
  GreaterThanOrEqual = 3,
  LessThanOrEqual = 4,
  DateRange = 5
}

export enum PermissionRights {
  None = 0,
  Create = 1 << 0,
  Read = 1 << 1,
  Update = 1 << 2,
  Delete = 1 << 3,
  Selectable = 1 << 4,
  All = Create | Read | Update | Delete | Selectable,
  Manage = Create | Read | Update | Delete
}
export enum FilterValueType {
  String = 0,
  Date = 1,
  DateTime = 2,
  Bool = 3,
  Int = 4,
  Double = 5,
  Guid = 6,
  List = 7
}
